// JavaScript Document
// Version: 1.2.1

var logosHistoryLimit = 9;
var historyGuid       = null;
var fileObj           = null;
var maxFileSize       = 3; // Valore espresso in MB.
var maxImageWidth     = 2000;
var maxImageHeight    = 2000;
var logoEditorItems = [];



jQuery(document).ready(function($) {
	var imprintMainCtx = getImprintMainCtx();

	/**
	 * Gestisce il caricamento di un logo.
	 * https://gitlab.com/meno/dropzone/-/tree/master
	 *
	 * @since 1.0.0
	 */
	$('#pills-imprint .wp-dropzone').each(function(index, element) {
		var that         = $(this);
		var ctx          = getPrintAreaParentTabCtx(that);
		var selectionCtx = getImageSelectionCtx(ctx);

		that.dropzone({
			paramName: "file", // The name that will be used to transfer the file
			maxFilesize: maxFileSize,
			acceptedFiles: 'image/png,image/jpg,image/jpeg,image/gif',
			url: that.attr('action').toString(),
			params: {
				security: $('input[name^="dropzone_nonce_field"]', that).val()
			},
			init: function() {
				this.on('addedfile', function(file) {
					displayLoading(true, null);
				});

				this.on('thumbnail', function(file) {
					if ( 'added' == file.status ) {
						if ( file.width > maxImageWidth ) {
							file.rejectWidth();
						} else if ( file.height > maxImageHeight ) {
							file.rejectHeight();
						} else {
							file.acceptDimensions();
						}
					} else {
						file.acceptDimensions();
					}
				});

				this.on('error', function(file) {
					if ( !file.accepted ) {
						this.removeFile(file);
					}
				});
			},
			complete: function(file) {
				console.log('complete');
				console.log(file);
			},
			accept: function(file, done) {
				console.log('accept');
				console.log(file);

				file.acceptDimensions = done;
            	file.rejectWidth      = function() {
					done(minerva_configurator_vars.fileupload_max_width);
				};
				file.rejectHeight     = function() {
					done(minerva_configurator_vars.fileupload_max_height);
				};
			},
			success: function(file, response) {
				console.log('success');
				console.log(file);
				console.log(response);

				if ( response.success ) {
					console.log('Logo uploaded successfully.');
					console.log(fileObj);

					// Aggiorno il localStorage.
					updateLocalStorage({
						fileName: response.fileName,
						action: 'add'
					}, function() {
						displayLoading(false, null);
						getHistoryNoticesCtx(selectionCtx).html('');
						selectionCtx.fadeOut(400, function() {
							initLogoEditor('filters', ctx, minerva_configurator_vars.wp_content_url + '/' + minerva_configurator_vars.assets_users + '/' + response.fileName);
						});
					});

				} else {
					console.log(response.error);

					displayLoading(false, null);
					getNoticesCtx(selectionCtx).html('<p class="text-secondary">' + response.error + '</p>');
				}
			},
			error: function(file, errorMessage) {
				console.log('error');
				console.log(file);
				console.log(errorMessage);

				var errorText = '';

				if ( errorMessage.startsWith('<!DOCTYPE html>') ) {
					var newDoc     = jQuery(errorMessage);
					var titleTag   = jQuery(newDoc[1]).text();
					var headingTag = jQuery('h1', newDoc).text();

					errorText      = ( '' != headingTag ) ? titleTag + '.<br>' + headingTag + '.' : titleTag + '.';
				} else {
					errorText      = errorMessage;
				}

				displayLoading(false, null);
				getNoticesCtx(selectionCtx).html('<p class="text-secondary">' + errorText + '</p>');
			},
			maxfilesreached: function(file) {
				console.log('maxfilesreached');
				console.log(file);
			},
			maxfilesexceeded: function(file) {
				console.log('maxfilesexceeded');
				console.log(file);
			},
			renameFile: function(file) {
				console.log('renameFile');
				console.log(file);

				if ( null == historyGuid ) {
					historyGuid = createGuid();
				}

				var fileType       = file.type;
				var fileExtension  = fileType.replace('image/', '');
				var microtime      = getMicrotime();
				var customFileName = historyGuid + '_' + microtime.toString().replace('.', '-') + '.' + fileExtension;

				fileObj            = {
					historyGuid: historyGuid,
					microtime: microtime,
					fileName: customFileName
				};

				return customFileName;
			},
			dictFileTooBig: minerva_configurator_vars.fileupload_max_file_size.replace('%d', maxFileSize), // "File is too big ({{filesize}}MiB). Max filesize: {{maxFilesize}}MiB.",
			dictInvalidFileType: minerva_configurator_vars.fileupload_accept_file_types,                   // "You can't upload files of this type.",
			dictMaxFilesExceeded: minerva_configurator_vars.fileupload_max_number_of_files,                // "You can not upload any more files.",
			previewsContainer: false
		});
	});



	/**
	 * Inizializza la history dei loghi.
	 *
	 * @since 1.0.0
	 */
	if ( typeof(Storage) !== 'undefined' ) {
		var logosHistoryValue = localStorage.getItem('logosHistory');

		if ( is_defined(logosHistoryValue) && null != logosHistoryValue ) {
			updateLogosGrid({
				action: 'init'
			}, function() {});
		}
	}



	/**
	 * Gestisce i pulsanti associati ad un logo della history.
	 *
	 * @since 1.1.0
	 */
	var logoHistoryCta = false;

	if ( $('body').hasClass('desktop') ) {
		imprintMainCtx.on('mouseenter', '.logos-history .item', function() {
			$(this).addClass('active');
		});

		$(document).on('mouseleave', '.logos-history .item', function() {
			$(this).removeClass('active');
		});
	} else {
		imprintMainCtx.on('click', '.logos-history .item', function() {
			$('.logos-history .item').removeClass('active');

			if ( !logoHistoryCta ) {
				$(this).addClass('active');
			} else {
				logoHistoryCta = false;
			}

			$('.actions .btn', $(this)).focusout();
		});
	}



	/**
	 * Gestisce il download di un logo dalla history.
	 *
	 * @since 1.0.0
	 */
	imprintMainCtx.on('click', '.logos-history .item.active .btnDownload', function() {
		var that       = $(this);
		var item       = that.closest('.item');
		var imageUrl   = $('img', item).attr('src');
		var fileName   = imageUrl.substr(imageUrl.lastIndexOf('/') + 1);
		var fileExt    = fileName.substr(fileName.lastIndexOf('.') + 1);
		var mimeTypes  = {
			jpeg: 'image/jpeg',
			jpg: 'image/jpeg',
			gif: 'image/gif',
			png: 'image/png'
		};
		var request    = new XMLHttpRequest();

		item.removeClass('active');

		logoHistoryCta = true;

		request.open('GET', imageUrl, true);

		request.responseType = 'blob';
		request.onload       = function(e) {
			download(request.response, fileName, fileName);
		}

		request.send();
	});



	/**
	 * Gestisce la cancellazione di un logo dalla history.
	 *
	 * @since 1.0.0
	 */
	imprintMainCtx.on('click', '.logos-history .item.active .btnRemove', function() {
		var that       = $(this);
		var item       = that.closest('.item');
		var imageUrl   = $('img', item).attr('src');
		// "fileName" è il nome del logo che devo eliminare.
		var fileName   = imageUrl.substr(imageUrl.lastIndexOf('/') + 1);

		item.removeClass('active');

		logoHistoryCta = true;

		$('#history-modal').attr('data-fname', fileName);
		$('#history-modal').modal('show');
	});

	$('#history-modal .btnRemove').on('click', function() {
		var fileName = $('#history-modal').attr('data-fname');

		$('#history-modal').modal('hide');
		displayLoading(true, null);
		deleteLogo(fileName, function() {
			displayLoading(false, null);
		});
	});



	/**
	 * Gestisce la selezione di un logo dalla history.
	 *
	 * @since 1.0.0
	 */
	imprintMainCtx.on('click', '.logos-history .item.active .btnUpdate', function() {
		var that         = $(this);
		var item         = that.closest('.item');
		var ctx          = getPrintAreaParentTabCtx(that);
		var imageUrl     = $('img', item).attr('src');
		var selectionCtx = getImageSelectionCtx(ctx);

		item.removeClass('active');

		logoHistoryCta   = true;

		getNoticesCtx(selectionCtx).html('');
		displayLoading(true, null);
		selectionCtx.fadeOut(400, function() {
			initLogoEditor('filters', ctx, imageUrl);
		});
	});



	$('.logos-grid .item img').load(function() {
		$(this).closest('.item').removeClass('loading');
	});



	/**
	 * Gestisce la rimozione di un'immagine applicata ad un'area di stampa.
	 * Il pulsante risulta visibile soltanto quando viene caricata una configurazione esistente.
	 *
	 * @since 1.0.0
	 */
	imprintMainCtx.on('click', '.btnRemoveImage', function() {
		var that       = $(this);
		var ctx        = getPrintAreaParentTabCtx(that);
		var areaId     = ctx.data('area-id');
		var previewCtx = getPreviewPrintAreaCtxByDataAttribute([
			{
				dataAttribute: 'area-id',
				attributeValue: areaId,
				dataRelation: '='
			}
		]);

		getPreviewPrintAreaContentCtx(previewCtx).remove();

		// Nel momento in cui cambia la configurazione della penna non c'è più ragione di mostrare il link alle configurazioni salvate.
		$('#saved-configurations-container').fadeOut();
		that.closest('.btn-remove-container').hide();
	});

});





/**
 * Restituisce il valore di microtime.
 *
 * @since 1.0.0
 */
function getMicrotime() {
	return (Date.now ? Date.now() : new Date().getTime()) / 1000;
}



/**
 * Recupera il guid associato alla history dei loghi.
 *
 * @since 1.0.0
 */
function getHistoryGuid() {
	if ( typeof(Storage) !== 'undefined' ) {
		var logosHistoryValue = localStorage.getItem('logosHistory');

		if ( is_defined(logosHistoryValue) && null != logosHistoryValue ) {
			logosHistoryValue = JSON.parse(logosHistoryValue);

			return logosHistoryValue.guid;
		} else {
			return createGuid();
		}
	}
}



/**
 * Inizializza il logo editor.
 *
 * @param {string}   type : tipo di logo editor da inizializzare
 * @param {selector} ctx  : contesto
 * @param {string}   url  : url dell'immagine da caricare nell'editor o base64 dell'immagine stessa
 *
 * @since 1.0.0
 */
function initLogoEditor(type, ctx, url) {
	switch( type ) {
		case 'filters':
			var filtersCtx = getImageFiltersCtx(ctx);

			jQuery('.filters-container div[class^=col-]', filtersCtx).append('<img src="' + url + '" class="editing-picture" style="display: none;">');

			filtersCtx.fadeIn();
			jQuery('canvas.lowres-canvas', filtersCtx).initFiltersEditor();
			break;
		case 'tuning':
			var tuningCtx = getImageFineTuningCtx(ctx);

			tuningCtx.fadeIn();
			jQuery('.tuning-container div[class^=col-]', tuningCtx).append('<img src="' + url + '" class="editing-picture" style="display: none;">');

			jQuery('canvas.lowres-canvas', tuningCtx).initTuningEditor();
			break;
	}
}



/**
 * Sanifica il nome del file.
 *
 * @param  {string} fileName : nome del file originale
 * @return {string}
 *
 * @since 1.0.0
 */
function sanitizeFileName(fileName) {
	return encodeURIComponent(fileName);
}



/**
 * Gestisce il salvataggio di un logo.
 *
 * @param {string}   fileName : nome del file con cui salvare il logo
 * @param {string}   base64   : base64 del logo
 * @param {function} callback : funzione di callback
 *
 * @since 1.0.0
 */
function saveLogo(fileName, base64, callback) {
	// Poiché i dati da memorizzare eccedono le dimensioni dei cookie è necessario ricorrere al localStorage/sessionStorage.
	if ( typeof(Storage) !== 'undefined' ) {
		// Salvo il logo sul server.

		var blob = base64ToBlob(base64);
		var fd   = new FormData();

		fd.append("action", 'minerva_save_logo');
		fd.append("fileName", fileName);
		fd.append("format", 'png');
		fd.append("imageFile", blob);

		jQuery('.overlay.fullscreen').show();
		jQuery.ajax({
			url: minerva_configurator_vars.ajaxurl,
			type: "POST",
			contentType: false,
			processData: false,
			cache: false,
			dataType: "json",
			data: fd,
			success: function(result) {
				if ( result.success ) {
					console.log('Logo "' + fileName + '" saved successfully.');

					// Aggiorno il localStorage.
					updateLocalStorage({
						fileName: fileName,
						action: 'add'
					}, callback);
				} else {
					console.log('Error saving logo.');
					// TO DO: mostrare un messaggio all'utente.
				}
			},
			error: function(error)  {
				console.log(error);
			}
		});
	} else {
		alert(minerva_configurator_vars.no_webs_storage_support);
	}
}



/**
 * Gestisce la cancellazione di un logo.
 *
 * @param {string}   fileName : nome del file relativo al logo da rimuovere
 * @param {function} callback : funzione di callback
 * @param {bool}     skip     :
 *
 * @since 1.0.0
 */
function deleteLogo(fileName, callback, skip) {
	// Rimuovo il file dal server.
	jQuery.ajax({
		url: minerva_configurator_vars.ajaxurl,
		type: "POST",
		dataType: "json",
		data: {
			action: 'minerva_delete_logo',
			fileName: fileName
		},
		success: function(result) {
			if ( result.success ) {
				console.log('Logo "' + fileName + '" deleted successfully.');
			} else {
				console.log('Error deleting logo.');
			}

			if ( is_defined(skip) && skip ) {
				callback();
			} else {
				// Indipendentemente dalla riuscita dell'operazione di cancellazione del file dal server, rimuovo il logo dal localStorage e dal markup HTML della history.

				// Aggiorno il localStorage.
				updateLocalStorage({
					fileName: fileName,
					action: 'remove'
				}, callback);
			}
		},
		error: function(error)  {
			console.log(error);
			callback();
		}
	});

}



/**
 * Aggiorna il markup HTML della history.
 * In questo punto dell'esecuzione del codice è già stato aggiornato il localStorage, quindi il numero di loghi memorizzati è già limitato.
 *
 * @param {object}   args     : oggetto così strutturato { action: 'init|add|remove', [fileName: 'nome del file'] }
 * @param {function} callback : funzione di callbak
 *
 * @since 1.0.0
 */
function updateLogosGrid(args, callback) {
	var selectionCtx      = getImageSelectionCtx();
	var gridCtx           = getHistoryGridCtx(selectionCtx);
	var noticesCtx        = getHistoryNoticesCtx(selectionCtx);
	var logosHistoryValue = localStorage.getItem('logosHistory');
	var action            = args.action;
	var fileName          = args.fileName;
	var gridItems         = jQuery('.item', gridCtx);

	if ( is_defined(logosHistoryValue) && null != logosHistoryValue ) {
		logosHistoryValue = JSON.parse(logosHistoryValue);

		var logos         = logosHistoryValue.logos;
		var baseUrl       = logosHistoryValue.baseUrl;
		var itemTemplate  = jQuery('<div class="item loading" data-fname="">' +
			'<img src="">' +
			'<div class="actions">' +
			'<button type="button" class="btn btn-default btn-ghost btn-circle btnDownload" title="' + minerva_configurator_vars.history_item_download + '"><i class="icon-download"></i></button>' +
			'<button type="button" class="btn btn-default btn-ghost btn-circle btnRemove" title="' + minerva_configurator_vars.history_item_remove + '"><i class="icon-trash"></i></button>' +
			'<button type="button" class="btn btn-primary btn-circle btnUpdate" title="' + minerva_configurator_vars.history_item_apply + '"><i class="icon-checkmark"></i></button>' +
			'</div>' +
			'</div>');

		switch( action ) {
			case 'init':
				// "reorderedLogos" è l'array con i loghi ordinato dal più recente al più vecchio.
				var reorderedLogos      = logos.reverse();
				var tempLogos           = [];
				var toBeDelete          = [];

				jQuery.each(reorderedLogos, function(index, element) {
					var tempItemTemplate = itemTemplate.clone().attr('data-fname', element);

					jQuery('img', tempItemTemplate).attr('src', baseUrl + element);

					if (index < logosHistoryLimit) {
						tempLogos.push(element);
						gridCtx.append(tempItemTemplate);
					} else {
						// Per qualche errore (da identificare) il localStorage contiene più loghi di quanto fissato.
						// Quindi elimino i loghi più vecchi.
						toBeDelete.push(element);
					}
				});

				logos                   = tempLogos.reverse();
				logosHistoryValue.logos = logos;

				localStorage.setItem('logosHistory', JSON.stringify(logosHistoryValue));

				if ( toBeDelete.length > 0 ) {
					jQuery.each(toBeDelete, function(index, element) {
						deleteLogo(element, function() {
							// do nothing.
						});
					});
				}
				break;
			case 'add':
				var tempItemTemplate = itemTemplate.clone().attr('data-fname', fileName).removeClass('loading');

				jQuery('img', tempItemTemplate).attr('src', baseUrl + fileName);
				gridCtx.prepend(tempItemTemplate);
				break;
			case 'remove':
				jQuery('.item[data-fname="' + fileName + '"]', gridCtx).remove();
				break;
		}

		// Mostro un messaggio di avvisto se è stato raggiunto il limite di capacità imposto alla history.
		if ( logos.length == logosHistoryLimit ) {
			noticesCtx.html('<p class="text-secondary">' + minerva_configurator_vars.history_limit_reached + '</p>');
		} else {
			noticesCtx.html('');
		}
	}

	callback();
}



/**
 * Aggiorna il localStorage.
 *
 * @param {object}   args     : oggetto così strutturato { action: 'add|remove', fileName: 'nome del file' }
 * @param {function} callback : funzione di callbak
 *
 * @since 1.0.0
 */
function updateLocalStorage(args, callback) {
	// Poiché i dati da memorizzare eccedono le dimensioni dei cookie è necessario ricorrere al localStorage/sessionStorage:
	//    - "window.localStorage" stores data with no expiration date
	//    - "window.sessionStorage" stores data for one session (data is lost when the browser tab is closed)
	//
	// Utilizzo:
	//    - localStorage.setItem({key}, {value})
	//    - localStorage.getItem({key})
	//    - localStorage.removeItem({key});
	if ( typeof(Storage) !== 'undefined' ) {
		var logosHistoryValue = localStorage.getItem('logosHistory');
		var fileName          = args.fileName;
		var action            = args.action;

		switch( action ) {
			case 'add':
				// Aggiungo il logo al localStorage.
				if ( is_defined(logosHistoryValue) && null != logosHistoryValue ) {
					logosHistoryValue = JSON.parse(logosHistoryValue);

					var logos         = logosHistoryValue.logos;

					if ( logos.length < logosHistoryLimit ) {
						// Se non è stato raggiunto il limite fissato per il localStorage, aggiungo il logo.
						logos.push(fileName);
						logosHistoryValue.logos = logos;
						_updateLocalStorage(logosHistoryValue, fileName, action, callback);
					} else {
						// Il localStorage ha raggiunto il limite fissato, quindi aggiungo il nuovo logo, eliminando nel contempo il logo più vecchio.
						logos.push(fileName);
						logosHistoryValue.logos = logos;
						localStorage.setItem('logosHistory', JSON.stringify(logosHistoryValue));
						deleteLogo(logos[0], callback);
					}
				} else {
					logosHistoryValue = {
						guid: historyGuid,
						baseUrl: minerva_configurator_vars.wp_content_url + '/' + minerva_configurator_vars.assets_users + '/',
						logos: [fileName]
					};
					_updateLocalStorage(logosHistoryValue, fileName, action, callback);
				}
				break;
			case 'remove':
				// Rimuovo il logo dal localStorage.
				if ( is_defined(logosHistoryValue) && null != logosHistoryValue ) {
					logosHistoryValue = JSON.parse(logosHistoryValue);

					var logos         = logosHistoryValue.logos;
					var newLogos      = jQuery.map(logos, function(element, index) {
						if ( fileName != element ) {
							return element;
						}
					});

					logosHistoryValue.logos = newLogos;
					_updateLocalStorage(logosHistoryValue, fileName, action, callback);
				}
				break;
		}
	} else {
		alert(minerva_configurator_vars.no_webs_storage_support);
	}
}

function _updateLocalStorage(logosHistoryValue, fileName, action, callback) {
	localStorage.setItem('logosHistory', JSON.stringify(logosHistoryValue));

	// Aggiorno il markup HTML della history.
	updateLogosGrid({
		fileName: fileName,
		action: action
	}, callback);
}



/**
 * Funzione per la ricerca di uno specifico filtro all'interno dell'array
 *
 * @since 1.0.0
 */
function findFilter(array, filterType) {
	var ret = -1;

	for (var i = 0; i < array.length; i++) {
		if (array[i].type == filterType) {
			ret = i;
			break;
		}
	}

	return ret;
};



/**
 * Logo editor con i filtri per l'elaborazione del logo.
 *
 * @since 1.0.0
 */
(function($) {
	$.fn.initFiltersEditor = function() {

		return this.each(function(index, element) {
			var activeTabpane    = getPrintAreaParentTabCtx($(this));
			var areaId           = activeTabpane.data('area-id');
			var context          = getImageFiltersCtx(activeTabpane);
			var container        = $('canvas', context).parent();
			var printAreaObj     = {
				id: activeTabpane.attr('data-area-id'),
				width: activeTabpane.attr('data-area-width'),
				height: activeTabpane.attr('data-area-height'),
				redius: activeTabpane.attr('data-area-radius'),
				left: $('canvas', context).width() / 2 - activeTabpane.attr('data-area-width') / 2,
				top: $('canvas', context).height() / 2 - activeTabpane.attr('data-area-height') / 2
			};
			var printArea        = $('<div></div>').addClass('print-area');
			var canvas           = new fabric.Canvas($('canvas.lowres-canvas', context).attr('id'));
			var scaleFactor;
			// A partire da FabricJS v.2.0.0 c'è il supporto ai display retina.
			var devicePixelRatio = 1;

			// Hires Canvas variables.
			var hiImageHeight    = minerva_configurator_vars.hi_image_height;
			var lowImageHeight   = minerva_configurator_vars.low_image_height;
			var cf               = hiImageHeight / lowImageHeight;
			var hiresCanvas      = new fabric.Canvas($('canvas.hires-canvas', context).attr('id'));
			var hiresPicture;
			var originalCanvas   = new fabric.Canvas($('canvas.original-canvas', context).attr('id'));
			var originalPicture;

			canvas.setDimensions({
				width: container.width(),
				height: '330'
			});

			logoEditorItems[areaId] = { 'canvas': canvas, 'printArea': printAreaObj };

			fabric.Image.fromURL($('.editing-picture', context).attr('src'), function(image) {
				image.set({
					borderColor: fabricBorderColor,
					borderScaleFactor: 1,
					cornerColor: fabricCornerColor,
					cornerSize: 12,
					lockRotation: true,
					transparentCorners: false
				});

				var imageWidth   = image.width;
				var imageHeight  = image.height;
				var canvasWidth  = parseFloat(canvas.width);
				var canvasHeight = parseFloat(canvas.height);

				if ( imageWidth > imageHeight ) {
					scaleFactor = canvasWidth / imageWidth;
				} else {
					scaleFactor = canvasHeight / imageHeight;
				}
				scaleFactor = Math.min(canvasWidth / imageWidth, canvasHeight / imageHeight);

				image.scale(parseFloat(scaleFactor));
				image.set({
					left: canvasWidth / 2 - image.width * scaleFactor / 2,
					top: canvasHeight /2 - image.height * scaleFactor / 2
				});
				// Imposto la visibilità dei controlli.
				image.setControlsVisibility({ bl: false, br: false, mb: false, ml: false, mr: false, mt: false, tl: false, tr: false });
				canvas.add(image);

				// Impedisco la modifica dell'immagine (spostamento, rotazione, zoom, selezione).
				canvas.item(0).hasControls      = false;
				canvas.item(0).hasBorders       = false;
				canvas.item(0).hasRotatingPoint = false;
				canvas.item(0).selectable       = false;
				canvas.item(0).hoverCursor      = "default";

				logoEditorItems[areaId].picture = image;


				// ORIGINAL CANVAS - START :: It contains the image in its original size, to avoid resolution loss between step 2 and 3
				// Moved here because the hires canvas must be initialized once that scaleFactor is defined.
				originalCanvas.setDimensions({
					width: imageWidth,
					height: imageHeight
				});

				fabric.Image.fromURL($('.editing-picture', context).attr('src'), function(image) {
					originalCanvas.add(image);
					originalPicture = image;

					logoEditorItems[areaId].originalCanvas  = originalCanvas;
					logoEditorItems[areaId].originalPicture = originalPicture;
				});
				// ORIGINAL CANVAS - END

				displayLoading(false, null);
			});


			// UPDATE
			$('.btnUpdateImage', context).off('click');
			$('.btnUpdateImage', context).on('click', function() {
				displayLoading(true, null);

				var ctx        = getPrintAreaParentTabCtx($(this));
				var multiplier = 1 / devicePixelRatio;

				// If transparent control is clicked remove disabled attributes form buttons and hide threshold slider.
				if ($('.btnTransparent', ctx).hasClass('active')) {
					$('.btn.active', ctx).removeClass('active');
					$('.btnGreyscale', ctx).removeAttr('disabled');
					$('.dropdown-controls.threshold', ctx).fadeOut();
				}

				logoEditorItems[areaId].canvas.discardActiveObject();


				// ORIGINAL CANVAS - START
				originalPicture.filters = [];
				$.each(logoEditorItems[areaId].picture.filters, function(index, element) {
					originalPicture.filters.push(logoEditorItems[areaId].picture.filters[index]);
				});

				originalPicture.applyFilters();
				originalCanvas.renderAll();

				var imageBytes = originalCanvas.toDataURL({
					left: originalPicture.left,
					top: originalPicture.top,
					width: originalPicture.width,
					height: originalPicture.height
				});
				// ORIGINAL CANVAS - END


				if ( logoEditorItems[areaId].picture.filters.length > 0 ) {
					// Salvo il logo nel localStorage soltanto se è stato applicato almeno un filtro.
					var fileExtension = 'png';
					var microtime     = getMicrotime();
					var fileName      = getHistoryGuid() + '_' + microtime.toString().replace('.', '-') + '.' + fileExtension;

					console.log({
						historyGuid: getHistoryGuid(),
						microtime: microtime,
						fileName: fileName
					});

					saveLogo(fileName, imageBytes, function() {
						filtersUpdateCallback(ctx.attr('data-area-id'), context, activeTabpane, imageBytes);
					});
				} else {
					filtersUpdateCallback(ctx.attr('data-area-id'), context, activeTabpane, imageBytes);
				}
			});


			// CANCEL
			$('.btnCancelImage', context).off('click');
			$('.btnCancelImage', context).on('click', function() {
				var ctx = getPrintAreaParentTabCtx($(this));

				// If transparent control is clicked remove disabled attributes form buttons and hide threshold slider.
				if ($('.btnTransparent', context).hasClass('active')) {
					$('.btn.active', context).removeClass('active');
					$('.btnGreyscale', context).removeClass('active');
					$('.dropdown-controls.threshold', context).fadeOut();
					$('.threshold-range', context).val(0);
					ctx.data('pickedcolor', null);
				}

				$('.canvas-container', $('.filters-container', context)).before($('<canvas id="image-filters-canvas-' + areaId + '" class="lowres-canvas"></canvas>'));

				logoEditorItems[areaId].canvas.clear();
				logoEditorItems[areaId] = null;


				// ORIGINAL CANVAS - START
				$('.canvas-container', $('.original-filters-container', context)).before($('<canvas id="image-original-filters-canvas-' + areaId + '" class="original-canvas"></canvas>'));
				originalCanvas.clear();
				// ORIGINAL CANVAS - END


				$('img', $('.canvas-container', context).parent()).remove();
				$('.canvas-container', context).remove();

				context.fadeOut(400, function() {
					removeImage(areaId, 'image');

					// Mostro lo step 1
					$('.image-selection', activeTabpane).fadeIn();
				});
			});

		});
	};
})(jQuery);



/**
 * Azioni da eseguire sull'update del logo editor con i filtri.
 *
 * @param {string}   areaId        : ID dell'area di stampa
 * @param {selector} context       : contesto
 * @param {selector} activeTabpane : pannello attivo
 * @param {string}   imageBytes    : base64 dell'immagine
 *
 * @since 1.0.0
 */
function filtersUpdateCallback(areaId, context, activeTabpane, imageBytes) {
	context.fadeOut(400, function() {
		displayLoading(false, null);
		jQuery('#saved-configurations-container').fadeOut();

		// Mostro lo step 3.
		getImageFineTuningCtx(activeTabpane).fadeIn();
		initLogoEditor('tuning', activeTabpane, imageBytes);
	});
}



/**
 * Logo editor per il posizionamento del logo.
 *
 * @since 1.0.0
 */
(function($){
	$.fn.initTuningEditor = function() {

		return this.each(function(index, element) {
			var activeTabpane      = getPrintAreaParentTabCtx($(this));
			var areaId             = activeTabpane.data('area-id');
			var context            = getImageFineTuningCtx(activeTabpane);
			var container          = $('canvas', context).parent();
			var dataAreaHeight 	   = parseFloat(activeTabpane.attr('data-area-height'));
			var dataAreaWidth 	   = parseFloat(activeTabpane.attr('data-area-width'));
			var dataAreaRadius     = activeTabpane.attr('data-area-radius');
			var printAreaObj       = {
				id: activeTabpane.attr('data-area-id'),
				width: dataAreaWidth,
				height: dataAreaHeight,
				radius: dataAreaRadius,
				left: $('canvas', context).width() / 2 - dataAreaWidth / 2,
				top: $('canvas', context).height() / 2 - dataAreaHeight / 2
			};
			var printArea          = $('<div></div>').addClass('print-area').attr('data-area-id', areaId);
			var cHeight;
			var gap                = 60;
			var activeImprintPanel = activeTabpane.closest('.imprint-panel.in');

			// Se necessario, aumento l'altezza del canvas per far stare tutta l'area di stampa.
			// In caso contrario, se possibile, ingrandisco l'area di stampa nel canvas per migliorare l'usabilità del logo editor.
			if ( $('canvas', context).height() > dataAreaHeight ) {
				cHeight            = Math.round($('canvas', context).height());
				printAreaObj.scale = ( cHeight - gap ) / printAreaObj.height ;
				// Poiché "printAreaObj.scale" è diverso da 1, devo correggere i valori di "left" e "top".
				printAreaObj.left  = $('canvas', context).width() / 2 - ( dataAreaWidth * printAreaObj.scale / 2 );
				printAreaObj.top   = cHeight / 2 - ( dataAreaHeight * printAreaObj.scale / 2 );
			} else {
				cHeight            = Math.round(printAreaObj.height) + gap;
				printAreaObj.top   = cHeight / 2 - dataAreaHeight / 2;
				printAreaObj.scale = 1;
			}

			var canvas 			   = new fabric.Canvas($('canvas.lowres-canvas', context).attr('id'));
			var scaleFactor;
			var rotation;
			// A partire da FabricJS v.2.0.0 c'è il supporto ai display retina.
			var devicePixelRatio   = 1; //window.devicePixelRatio;

			// Hires Canvas variables.
			var hiImageHeight      = minerva_configurator_vars.hi_image_height;
			var lowImageHeight     = minerva_configurator_vars.low_image_height;
			var cf                 = hiImageHeight / lowImageHeight;
			var hiresCanvas        = new fabric.Canvas($('canvas.hires-canvas', context).attr('id'));
			var hiresPicture;

			printArea.css('width', printAreaObj.width * printAreaObj.scale);
			printArea.css('height', printAreaObj.height * printAreaObj.scale);
			printArea.css('border-radius', printAreaObj.radius);
			printArea.css('left', printAreaObj.left);
			printArea.css('top', printAreaObj.top);

			canvas.setDimensions({
				width: container.width(),
				height: cHeight
			});

			$('.tuning-container .canvas-container div.print-area', context).remove();
			$('.tuning-container .canvas-container', context).append(printArea);

			logoEditorItems[areaId].tuningCanvas    = canvas;
			logoEditorItems[areaId].tuningPrintArea = printAreaObj;

			fabric.Image.fromURL($('.editing-picture', context).attr('src'), function(image) {
				image.set({
					borderColor: fabricBorderColor,
					borderScaleFactor: 1,
					cornerColor: fabricCornerColor,
					cornerSize: 8,
					lockRotation: true,
					transparentCorners: false
				});

				var imageWidth      = image.width;
				var imageHeight     = image.height;
				var canvasWidth     = parseFloat(canvas.width);
				var canvasHeight    = parseFloat(canvas.height);
				var printAreaWidth  = parseFloat(printAreaObj.width);
				var printAreaHeight = parseFloat(printAreaObj.height);
				var rotation        = 0;

				if ( '0' != printAreaObj.radius ) {
					// Per ora è gestita solo un'area di stampa circolare.
					rotation           = 0;

					var newImageHeight = printAreaWidth / Math.sqrt(1 + Math.pow(imageWidth / imageHeight, 2));

					if ( imageHeight > newImageHeight ) {
						scaleFactor = (newImageHeight / imageHeight) * printAreaObj.scale;
					} else {
						scaleFactor = (imageHeight / newImageHeight) * printAreaObj.scale;
					}
				} else {
					if ( imageWidth > imageHeight ) {
						rotation    = -90;
						scaleFactor = Math.min(printAreaHeight / imageWidth, printAreaWidth / imageHeight) * printAreaObj.scale;
					} else {
						rotation    = 0;
						scaleFactor = Math.min(printAreaWidth / imageWidth, printAreaHeight / imageHeight) * printAreaObj.scale;
					}
				}

				image.scale(scaleFactor);
				image.set({
					left: canvasWidth / 2,
					top: canvasHeight /2,
					originX: "center",
        			originY: "center"
				});
				image.rotate(rotation);
				image.setControlsVisibility({ bl: true, br: true, mb: false, ml: false, mr: false, mt: false, tl: true, tr: true });
				canvas.add(image);

				logoEditorItems[areaId].tuningPicture = image;

				// CANVAS HIRES - START :: Moved here because the hires canvas must be initialized once that scaleFactor is defined.
				hiresCanvas.setDimensions({
					width: canvas.width * cf,
					height: canvas.height * cf
				});

				logoEditorItems[areaId].hiresCanvas = hiresCanvas;

				fabric.Image.fromURL($('.editing-picture', context).attr('src'), function(image) {
					image.scale(scaleFactor * cf);
					image.set({
						left: parseFloat(hiresCanvas.width) / 2,
						top: parseFloat(hiresCanvas.height) /2,
						originX: "center",
						originY: "center"
					});
					image.rotate(rotation);

					hiresCanvas.add(image);
					hiresPicture    = image;
					paHiLeft        = hiresCanvas.width / 2 -  dataAreaWidth * cf  * printAreaObj.scale / 2;
					paHiTop         = hiresCanvas.height / 2 -  dataAreaHeight * cf  * printAreaObj.scale / 2;

					logoEditorItems[areaId].hiresPicture = hiresPicture;

					var printAreaHi = $('<div></div>').addClass('print-area').addClass('high');

					printAreaHi.css('width', printAreaObj.width * cf * printAreaObj.scale);
					printAreaHi.css('height', printAreaObj.height * cf * printAreaObj.scale);
					printAreaHi.css('border-radius', printAreaObj.radius);
					printAreaHi.css('left', paHiLeft);
					printAreaHi.css('top', paHiTop);

					$('.hires-tuning-container .canvas-container div.print-area.high', context).remove();
					$('.hires-tuning-container .canvas-container', context).append(printAreaHi);

					// Initial crop and update of the preview
					logoEditorItems[areaId].printAreaHi = {
						left: paHiLeft,
						top: paHiTop,
						width: printAreaObj.width * cf * printAreaObj.scale,
						height: printAreaObj.height * cf * printAreaObj.scale,
						radius: printAreaObj.radius
					};

					// APPLICO SUBITO L'IMMAGINE RUOTATA E RISCALATA ALL'AREA DI STAMPA
					hiresPicture.rotate(logoEditorItems[areaId].tuningPicture.angle);
					hiresPicture.left   = logoEditorItems[areaId].tuningPicture.left * cf;
					hiresPicture.top    = logoEditorItems[areaId].tuningPicture.top * cf;
					hiresPicture.scaleX = logoEditorItems[areaId].tuningPicture.scaleX * cf;
					hiresPicture.scaleY = logoEditorItems[areaId].tuningPicture.scaleY * cf;

					hiresCanvas.renderAll();

					var imageBytes = hiresCanvas.toDataURL({
						left: logoEditorItems[areaId].printAreaHi.left,
						top: logoEditorItems[areaId].printAreaHi.top,
						width: logoEditorItems[areaId].printAreaHi.width,
						height: logoEditorItems[areaId].printAreaHi.height
					});

					if ( printAreaObj.scale != 1 ) {
						var resize     = 1 / printAreaObj.scale;
						var tempImg    = new Image();

						tempImg.src    = imageBytes;
						tempImg.onload = function() {
							var tempCanvas  = new fabric.Canvas(jQuery('<canvas></canvas>')[0]);

							tempCanvas.setDimensions({
								width: tempImg.width * resize,
								height: tempImg.height * resize,
							});

							var imgInstance = new fabric.Image(tempImg, {
								left: 0,
								top: 0
							});

							imgInstance.scale(resize);
							tempCanvas.add(imgInstance);
							tempCanvas.renderAll();
							imageBytes = tempCanvas.toDataURL({
								left: 0,
								top: 0,
								width: tempCanvas.width,
								height: tempCanvas.height
							});

							appendImage(activeTabpane.attr('data-area-id'), imageBytes, 'image');
						};
					} else {
						appendImage(activeTabpane.attr('data-area-id'), imageBytes, 'image');
					}

				});
				// CANVAS HIRES - END

				displayLoading(false, null);
			});


			// UPDATE
			$('.btnUpdateImage', context).off('click');
			$('.btnUpdateImage', context).on('click', function() {
				displayLoading(true, '');

				var ctx        = getPrintAreaParentTabCtx($(this));
				var areaId     = ctx.data('area-id');
				var multiplier = 1 / devicePixelRatio;

				logoEditorItems[areaId].tuningCanvas.discardActiveObject();

				// CANVAS HIRES - START
				hiresPicture.rotate(logoEditorItems[areaId].tuningPicture.angle);
				hiresPicture.left    = logoEditorItems[areaId].tuningPicture.left * cf;
				hiresPicture.top     = logoEditorItems[areaId].tuningPicture.top * cf;
				hiresPicture.scaleX  = logoEditorItems[areaId].tuningPicture.scaleX * cf;
				hiresPicture.scaleY  = logoEditorItems[areaId].tuningPicture.scaleY * cf;

				// Viene applicato un clipPath circolare se "radius" != "0".
				// Per ora è gestita solo un'area di stampa circolare: radius = witdh / 2 = height / 2.
				if ( '0' != ctx.data('area-radius') ) {
					var radius = logoEditorItems[areaId].printAreaHi.width / 2;

					hiresPicture.clipPath = new fabric.Circle({
						radius: radius,
						absolutePositioned: true,
						left: paHiLeft + radius,
						top: paHiTop + radius,
						originX: 'center',
						originY: 'center',
					});

					hiresPicture.dirty = true;
				}

				hiresCanvas.renderAll();

				var imageBytes = hiresCanvas.toDataURL({
					left: logoEditorItems[areaId].printAreaHi.left,
					top: logoEditorItems[areaId].printAreaHi.top,
					width: logoEditorItems[areaId].printAreaHi.width,
					height: logoEditorItems[areaId].printAreaHi.height
				});

				if ( printAreaObj.scale != 1 ) {
					var resize     = 1 / printAreaObj.scale;
					var tempImg    = new Image();

					tempImg.src    = imageBytes;
					tempImg.onload = function() {
						var tempCanvas  = new fabric.Canvas(jQuery('<canvas></canvas>')[0]);

						tempCanvas.setDimensions({
							width: tempImg.width * resize,
							height: tempImg.height * resize,
						});

						var imgInstance = new fabric.Image(tempImg, {
							left: 0,
							top: 0
						});

						imgInstance.scale(resize);
						tempCanvas.add(imgInstance);
						tempCanvas.renderAll();
						imageBytes = tempCanvas.toDataURL({
							left: 0,
							top: 0,
							width: tempCanvas.width,
							height: tempCanvas.height
						});

						tuningUpdateCallback(ctx.attr('data-area-id'), imageBytes, ctx.closest('.imprint-panel').attr('data-component-id'));
					};
				} else {
					tuningUpdateCallback(ctx.attr('data-area-id'), imageBytes, ctx.closest('.imprint-panel').attr('data-component-id'));
				}
				// CANVAS HIRES - END

			});


			// CANCEL
			$('.btnCancelImage', context).off('click');
			$('.btnCancelImage', context).on('click', function() {
				var ctx    = getPrintAreaParentTabCtx($(this));
				var areaId = ctx.data('area-id');

				$('.canvas-container', $('.tuning-container', context)).before($('<canvas id="image-tuning-canvas-' + areaId + '" class="lowres-canvas"></canvas>'));

				logoEditorItems[areaId].tuningCanvas.clear();
				logoEditorItems[areaId].tuningPicture = null;

				// CANVAS HIRES - START
				$('.canvas-container', $('.hires-tuning-container', context)).before($('<canvas id="image-hires-tuning-canvas-' + areaId + '" class="hires-canvas"></canvas>'));
				hiresCanvas.clear();
				// CANVAS HIRES - END

				$('img', $('.canvas-container', context).parent()).remove();
				$('.canvas-container', context).remove();

				context.fadeOut(400, function() {
					// Mostro lo step 2.
					getImageFiltersCtx(activeTabpane).fadeIn();
				});
			});

		});
	};
})(jQuery);



/**
 * Azioni da eseguire sull'update del logo editor con i controlli di posizionamento.
 *
 * @param {string} areaId      : ID dell'area di stampa
 * @param {string} imageBytes  : base64 dell'immagine
 * @param {string} componentId : ID del componente
 *
 * @since 1.0.0
 */
function tuningUpdateCallback(areaId, imageBytes, componentId) {
	appendImage(areaId, imageBytes, 'image');
	displayLoading(false, null);
	jQuery('#saved-configurations-container').fadeOut();
}



/**
 * Binding degli handler ai vari pulsanti: il bind viene fatto su tutti i "tab-pane" di tutte le aree di stampa.
 *
 * @since 1.0.0
 */
jQuery('document').ready(function($) {

	// DISCOLOR (STEP 2)
	$('.image-filters .btnGreyscale').on('click', function() {
		$(this).toggleClass('active');

		var ctx       = getPrintAreaParentTabCtx($(this));
		var areaId    = ctx.data('area-id');
		var filterRef = findFilter(logoEditorItems[areaId].picture.filters, 'Grayscale');

		if (($(this).hasClass('active')) && (filterRef < 0)) {
			logoEditorItems[areaId].picture.filters.push(new fabric.Image.filters.Grayscale());
		} else {
			logoEditorItems[areaId].picture.filters.splice(filterRef, 1);
		}

		logoEditorItems[areaId].picture.applyFilters();
		logoEditorItems[areaId].canvas.renderAll();
	});


	// NEGATIVE (STEP 2)
	$('.image-filters .btnNegative').on('click', function() {
		$(this).toggleClass('active');

		var ctx       = getPrintAreaParentTabCtx($(this));
		var areaId    = ctx.data('area-id');
		var filterRef = findFilter(logoEditorItems[areaId].picture.filters, 'Invert');

		if (($(this).hasClass('active')) && (filterRef < 0)) {
			logoEditorItems[areaId].picture.filters.push(new fabric.Image.filters.Invert());
		} else {
			logoEditorItems[areaId].picture.filters.splice(filterRef, 1);
		}

		logoEditorItems[areaId].picture.applyFilters();
		logoEditorItems[areaId].canvas.renderAll();
	});


	// RICOLORA - BIANCO (STEP 2)
	$('.image-filters .btnBlendWhite').on('click', function() {
		var activeTabpane = getPrintAreaParentTabCtx($(this));
		var context       = getImageFiltersCtx(activeTabpane);

		$(this).toggleClass('active');

		var areaId        = activeTabpane.data('area-id');
		var filterRef     = findFilter(logoEditorItems[areaId].picture.filters, 'BlendColor');

		if ( $(this).hasClass('active') ) {
			// Se è già presente un filtro "BlendColor" (quello per ricolorare di nero) viene rimosso e viene resettato il corrispondente pulsante.
			if ( filterRef >= 0 ) {
				logoEditorItems[areaId].picture.filters.splice(filterRef, 1);
				$('.btnBlendBlack', context).removeClass('active');
			}
			logoEditorItems[areaId].picture.filters.push(new fabric.Image.filters.BlendColor({ color: '#FFFFFF', mode: 'tint', alpha: 1 }));
		} else {
			logoEditorItems[areaId].picture.filters.splice(filterRef, 1);
		}

		logoEditorItems[areaId].picture.applyFilters();
		logoEditorItems[areaId].canvas.renderAll();
	});


	// RICOLORA - NERO (STEP 2)
	$('.image-filters .btnBlendBlack').on('click', function() {
		var activeTabpane = getPrintAreaParentTabCtx($(this));
		var context       = getImageFiltersCtx(activeTabpane);

		$(this).toggleClass('active');

		var areaId        = activeTabpane.data('area-id');
		var filterRef     = findFilter(logoEditorItems[areaId].picture.filters, 'BlendColor');

		if ( $(this).hasClass('active') ) {
			// Se è già presente un filtro "BlendColor" (quello per ricolorare di bianco) viene rimosso e viene resettato il corrispondente pulsante.
			if ( filterRef >= 0 ) {
				logoEditorItems[areaId].picture.filters.splice(filterRef, 1);
				$('.btnBlendWhite', context).removeClass('active');
			}
			logoEditorItems[areaId].picture.filters.push(new fabric.Image.filters.BlendColor({ color: '#000000', mode: 'tint', alpha: 1 }));
		} else {
			logoEditorItems[areaId].picture.filters.splice(filterRef, 1);
		}

		logoEditorItems[areaId].picture.applyFilters();
		logoEditorItems[areaId].canvas.renderAll();
	});


	// TRANSPARENT COLOR (STEP 2)
	$('.image-filters .btnTransparent').on('click', function() {
		var activeTabpane = getPrintAreaParentTabCtx($(this));
		var context       = getImageFiltersCtx(activeTabpane);

		$(this).toggleClass('active');

		$('.dropdown-controls.threshold', context).fadeIn();

		var areaId        = activeTabpane.data('area-id');
		var filterRef     = findFilter(logoEditorItems[areaId].picture.filters, 'RemoveColor');

		if ( $(this).hasClass('active') ) {
			logoEditorItems[areaId].canvas._onPickColor = function(options) {
				$('.btnPickcolor', context).removeClass('active');

				// options.target is set only if object is selectable.
				if ( options.target ) {
					var newFilterObj = new fabric.Image.filters.RemoveColor({ color: activeTabpane.attr('data-pickedcolor'), distance: $('.threshold-range', context).val() });

					if ( filterRef < 0 ) {
						// .push() returns the new length of the array: filterRef is the index of the element added == array length - 1.
						filterRef = logoEditorItems[areaId].picture.filters.push(newFilterObj) - 1;
					} else {
						logoEditorItems[areaId].picture.filters[filterRef] = newFilterObj;
					}

					logoEditorItems[areaId].picture.applyFilters();
					logoEditorItems[areaId].canvas.renderAll();
				}

				logoEditorItems[areaId].canvas.off('mouse:up', logoEditorItems[areaId].canvas._onPickColor);
				logoEditorItems[areaId].canvas.off('mouse:move');
				logoEditorItems[areaId].picture.hoverCursor = 'default';
			};

			$('.threshold-range', context).on('input', function(e) {
				if ( activeTabpane.attr('data-pickedcolor') != null ) {
					if ( logoEditorItems[areaId].picture.filters[filterRef] != null ) {
						logoEditorItems[areaId].picture.filters[filterRef].distance =  this.value;
					}

					logoEditorItems[areaId].picture.applyFilters();
					logoEditorItems[areaId].canvas.renderAll();
				}
			});


			$('.btnPickcolor', context).on('click', function() {
				$(this).addClass('active');

				// Listen for mouse events.
				logoEditorItems[areaId].picture.hoverCursor = 'crosshair';
				logoEditorItems[areaId].canvas.on('mouse:up', logoEditorItems[areaId].canvas._onPickColor);
				logoEditorItems[areaId].canvas.on('mouse:move', function(e) {
					// Get the current mouse position.
					var mouse = logoEditorItems[areaId].canvas.getPointer(e.e);
					var x     = e.e.offsetX * window.devicePixelRatio; //parseInt(mouse.x);
					var y     = e.e.offsetY * window.devicePixelRatio; //parseInt(mouse.y);
					// Get the color array for the pixel under the mouse.
					var px    = this.getContext("2d").getImageData(x, y, 1, 1).data;

					// report activeTabpane pixel data
					activeTabpane.attr('data-pickedcolor', 'rgb(' + px[0] + ',' + px[1] + ',' + px[2] + ')');
					$('.color-sample', activeTabpane).attr('style', 'background: rgba(' + px[0] + ',' + px[1] + ',' + px[2] + ',1); border-color: transparent;');
				});
			});
		} else {
			// Il valore precedente è -1, perchè viene preso PRIMA di aggiungere il filtro.
			filterRef = findFilter(logoEditorItems[areaId].picture.filters, 'RemoveColor');

			if ( filterRef > -1 ) {
				logoEditorItems[areaId].picture.filters.splice(filterRef, 1);
			}
			logoEditorItems[areaId].canvas.off('mouse:up', logoEditorItems[areaId].canvas._onPickColor);
			logoEditorItems[areaId].canvas.off('mouse:move');
			logoEditorItems[areaId].picture.hoverCursor = 'auto';

			$('.dropdown-controls.threshold', activeTabpane).fadeOut();
			$('.threshold-range', context).off('input');
			$('.btnPickcolor', context).off('click');
			$('.color-sample', activeTabpane).removeAttr('style');

			logoEditorItems[areaId].picture.applyFilters();
			logoEditorItems[areaId].canvas.renderAll();
		}
	});


	// DOWNLOAD (STEP 2)
	$('.image-filters .btnDownload').on('click', function() {
		var activeTabpane       = getPrintAreaParentTabCtx($(this));
		var context             = getImageFiltersCtx(activeTabpane);
		var areaId              = activeTabpane.data('area-id');
		var originalCanvas      = logoEditorItems[areaId].originalCanvas;
		var originalPicture     = logoEditorItems[areaId].originalPicture;

		originalPicture.filters = [];

		$.each(logoEditorItems[areaId].picture.filters, function(index, element) {
			originalPicture.filters.push(logoEditorItems[areaId].picture.filters[index]);
		});

		originalPicture.applyFilters();
		originalCanvas.renderAll();

		var imageBytes = originalCanvas.toDataURL({
			left: originalPicture.left,
			top: originalPicture.top,
			width: originalPicture.width,
			height: originalPicture.height
		});

		download(imageBytes, 'download.png', 'image/png');
	});


	// ROTATE (STEP 3)
	$('.image-fine-tuning .btnRotate').on('click', function() {
		var areaId = getPrintAreaParentTabCtx($(this)).data('area-id');

		logoEditorItems[areaId].tuningPicture.rotate(logoEditorItems[areaId].tuningPicture.angle - 90);
		logoEditorItems[areaId].tuningCanvas.renderAll();
	});


	// ZOOM IN (STEP 3)
	$('.image-fine-tuning .btnZoomIn').on('click', function() {
		var areaId = getPrintAreaParentTabCtx($(this)).data('area-id');

		logoEditorItems[areaId].tuningPicture.scale(logoEditorItems[areaId].tuningPicture.scaleX *= 1.05);
		logoEditorItems[areaId].tuningCanvas.renderAll();
	});


	// ZOOM OUT (STEP 3)
	$('.image-fine-tuning .btnZoomOut').on('click', function() {
		var areaId = getPrintAreaParentTabCtx($(this)).data('area-id');

		logoEditorItems[areaId].tuningPicture.scale(logoEditorItems[areaId].tuningPicture.scaleX *= 0.95);
		logoEditorItems[areaId].tuningCanvas.renderAll();
	});


	// DOWN (STEP 3)
	$('.image-fine-tuning .btnDown').on('click', function() {
		var areaId = getPrintAreaParentTabCtx($(this)).data('area-id');

		logoEditorItems[areaId].tuningPicture.top = logoEditorItems[areaId].tuningPicture.top += 1;
		logoEditorItems[areaId].tuningCanvas.renderAll();
	});


	// UP (STEP 3)
	$('.image-fine-tuning .btnUp').on('click', function() {
		var areaId = getPrintAreaParentTabCtx($(this)).data('area-id');

		logoEditorItems[areaId].tuningPicture.top = logoEditorItems[areaId].tuningPicture.top -= 1;
		logoEditorItems[areaId].tuningCanvas.renderAll();
	});


	// LEFT (STEP 3)
	$('.image-fine-tuning .btnLeft').on('click', function() {
		var areaId = getPrintAreaParentTabCtx($(this)).data('area-id');

		logoEditorItems[areaId].tuningPicture.left = logoEditorItems[areaId].tuningPicture.left -= 1;
		logoEditorItems[areaId].tuningCanvas.renderAll();
	});


	// RIGHT (STEP 3)
	$('.image-fine-tuning .btnRight').on('click', function() {
		var areaId = getPrintAreaParentTabCtx($(this)).data('area-id');

		logoEditorItems[areaId].tuningPicture.left = logoEditorItems[areaId].tuningPicture.left += 1;
		logoEditorItems[areaId].tuningCanvas.renderAll();
	});

});
